import type { Props } from './types';

const GenAILogo = ({ className }: Props) => (
  <img
    alt="logo"
    className={className}
    src="https://cdn-cms-uploads.picsart.com/cms-uploads/c5372821-bf22-4d75-98c6-0f91503eb996.svg"
  />
);

export default GenAILogo;
